"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Checkbox_1 = require("../checkbox/Checkbox");
var TermsAndConditionsModal_1 = require("./TermsAndConditionsModal");
var TermsAndConditions = function (_a) {
    var isAccepted = _a.isAccepted, setIsAccepted = _a.setIsAccepted;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var handleTermsClick = react_1.useCallback(function () {
        if (isAccepted) {
            return setIsAccepted(false);
        }
        return setIsOpen(true);
    }, [isAccepted]);
    return (<>
      <Checkbox_1.default data-test={'checkout:identityVerification:terms'} label={'trans__checkout__next_step__customer_information__terms_and_conditions__order_online'} value={isAccepted} onClick={handleTermsClick}/>
      <TermsAndConditionsModal_1.default isOpen={isOpen} setIsOpen={setIsOpen} setIsAccepted={setIsAccepted}/>
    </>);
};
exports.default = TermsAndConditions;
